import React, { memo, useCallback } from "react";
import { ReportData } from "../../types/global.d";
import { FilterType } from "./reportsUtils";
import ReportsListContent from "./ReportsListContent";
import {
  useReportsSearch,
  useReportsFilter,
  useSelectedReportScroll,
} from "./useSidebarHooks";
import "../../components/styles/ReportsList.css";

interface ReportsListProps {
  reports: ReportData[];
  onReportClick?: (report: ReportData) => void;
  selectedReportId?: string | null;
  onClose?: () => void;
  onFilterChange?: (filter: FilterType) => void;
  userFilter?: string | null;
  onUserFilterChange?: (nickname: string | null) => void;
}

const ReportsList: React.FC<ReportsListProps> = memo(
  ({ reports, onReportClick, selectedReportId, onClose, onFilterChange, userFilter, onUserFilterChange }) => {
    const { searchTerm, setSearchTerm } = useReportsSearch();
    const { selectedFilter, setSelectedFilter } = useReportsFilter();
    const { selectedItemRef } = useSelectedReportScroll(selectedReportId);

    const handleReportClick = useCallback(
      (report: ReportData) => {
        if (onReportClick) {
          onReportClick(report);
        }
      },
      [onReportClick]
    );

    const handleFilterChange = useCallback(
      (filter: FilterType) => {
        setSelectedFilter(filter);
        if (onFilterChange) {
          onFilterChange(filter);
        }
      },
      [setSelectedFilter, onFilterChange]
    );

    return (
      <ReportsListContent
        reports={reports}
        onReportClick={handleReportClick}
        selectedReportId={selectedReportId}
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
        selectedFilter={selectedFilter}
        onFilterChange={handleFilterChange}
        selectedItemRef={selectedItemRef}
        onClose={onClose}
        userFilter={userFilter}
        onUserFilterChange={onUserFilterChange}
      />
    );
  }
);

ReportsList.displayName = "ReportsList";

export default ReportsList;
